import MemberBankService from "../../services/MemberBankService";
export const SET_BANK_ACCOUNT = "SET_BANK_ACCOUNT";
export const DELETE_BANK_ACCOUNT = "DELETE_BANK_ACCOUNT";

export function changeBankAccount(membershipNumber, bankObj) {
  let service = new MemberBankService();
  return dispatch =>
    service
      .UpdateMemberBankDetails(membershipNumber, bankObj)
      .then(data => {
        dispatch({
          type: SET_BANK_ACCOUNT,
          payload: {
            MembershipNumber: membershipNumber,
            MemberBank: data.MemberBankDetail
          }
        });
        return data;
      });
}

export function deleteBankAccount(MembershipNumber,ClientId ) {
  let service = new MemberBankService();
  return dispatch =>
    service.DeleteMemberBankDetails( MembershipNumber,ClientId).then(data => {
      dispatch({
        type: DELETE_BANK_ACCOUNT,
        payload: {
          MembershipNumber: MembershipNumber,
          MemberBank: data.Obj
        }
      });
      return data;
    });
}
